import { createContext, useContext } from "react";

// Підписи плеєра мовою курсу. Англійські уроки — як були (англійською); курси іншої мови мають префікс мови
// в course ("es-kids-a1") — для них підписи цією мовою, щоб дитина не бачила англійських слів на уроці іспанської.
const ES = {
  Lesson: "Lección",
  "Trial lesson": "Clase de prueba",
  "Today you will": "Hoy aprendes",
  Next: "Siguiente",
  Example: "Ejemplo",
  Reset: "Otra vez",
  Listen: "Escucha",
  "+1 star for your homework": "+1 estrella por tus deberes",
  "You hear:": "Oyes:",
  "You write:": "Escribes:",
  // розділи слайдів (slide.section)
  "Warm-up": "Calentamiento",
  Vocabulary: "Vocabulario",
  Grammar: "Gramática",
  Listening: "Escuchar",
  Reading: "Leer",
  Speaking: "Hablar",
  Writing: "Escribir",
  Pronunciation: "Pronunciación",
  Game: "Juego",
  Review: "Repaso",
  Video: "Vídeo",
  Homework: "Deberes",
};
const DICTS = { es: ES };

export const langOfCourse = (course = "") => (/^([a-z]{2})-/.exec(course) || [])[1] || "en";
export const LessonLang = createContext("en");
export const useT = () => {
  const dict = DICTS[useContext(LessonLang)];
  return (key) => (dict && dict[key]) || key;
};
